import { forkJoin } from 'rxjs';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { User } from '../../../shared/models';
import { FormGroup, FormBuilder, Validators, NgForm, FormControl, ValidationErrors } from '@angular/forms';
import { ICountry } from '../../../shared/models/country.interface';
import { CountryService } from '../../../shared/services/country.service';
import { UserService } from '../../../shared/services';
import { UserRoleEnum } from '../../../shared/common/user-role.enum';
import { ToastyService } from 'ng2-toasty';
import { Enterprise, Representative } from '../../../shared/models/enterprise.model';
import { AssociationService } from '../../../shared/services/association.service';
import { Association } from '../../../shared/models/association.model';
import { AssocUser } from 'app/shared/models/assoc-user.model';
@Component({
  selector: 'app-user-edition',
  templateUrl: './user-edition.component.html',
  styleUrls: ['./user-edition.component.css']
})
export class UserEditionComponent implements OnInit {

  public user: User;
  public userDetailsForm: FormGroup;
  public passwordForm: FormGroup;
  public companyDetailsForm: FormGroup;
  public repDetailsForm: FormGroup;
  public isCompany = false;
  public isAssociation = false;
  public associations: Association[];

  public countries: ICountry[] = [];

  constructor(private route: ActivatedRoute, private formBuilder: FormBuilder,
    private countryService: CountryService, private userService: UserService,
    private toastyService: ToastyService, private associationService: AssociationService) {
    this.user = this.route.snapshot.data['user'];
    this.isCompany = UserRoleEnum.COMPANY === this.user.role.id;
    this.isAssociation = UserRoleEnum.ASSOCIATION === this.user.role.id;

    // tslint:disable-next-line:max-line-length
    const patternEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    this.userDetailsForm = formBuilder.group({
      'name': ['', [Validators.required]],
      'firstname': ['', [Validators.required]],
      'email': ['', [Validators.required, Validators.pattern(patternEmail)]],
      'mobile': [''],
      'birth_date': ['']
    });

    this.passwordForm = formBuilder.group({
      'password': [''],
      'password_confirmation': ['']
    }, { validator: this.checkIfMatchingPasswords('password', 'password_confirmation') });

    this.countryService.getCountries().subscribe(
      data => {
        this.countries = this.move(data, data.indexOf(data.filter(country => country.alpha2Code === 'FR')[0]), 0);
      }
    );

    this.associationService.list().subscribe(data => {
      this.associations = data;
    });

  }

  ngOnInit() {
    if (this.isCompany) {
      this.companyDetailsForm = this.formBuilder.group({
        'enterprise_name': [this.user.entreprise ? this.user.entreprise.enterprise_name : '', [Validators.required]],
        'siren': [this.user.entreprise ? this.user.entreprise.siren : '', [Validators.required]],
        'legal_form': [this.user.entreprise ? this.user.entreprise.legal_form : '', [Validators.required]],
        'address': [this.user.user_adress ? this.user.user_adress.address_line_1 : '', [Validators.required]],
        'city': [this.user.user_adress ? this.user.user_adress.city : '', [Validators.required]],
        'country': [this.user.user_adress ? this.user.user_adress.country_iso : '', Validators.required],
        'post_code': [this.user.user_adress ? this.user.user_adress.post_code : '', Validators.required],
        'mob_phone': [this.user.entreprise.mob_phone ? this.user.entreprise.mob_phone : '']
      });
      this.repDetailsForm = this.formBuilder.group({
        'rep_name': [this.user.representative ? this.user.representative.name : '', [Validators.required]],
        'rep_firstname': [this.user.representative ? this.user.representative.firstname : '', [Validators.required]],
        'rep_email': [this.user.representative ? this.user.representative.email : '', [Validators.required]],
        'rep_country': [this.user.representative ? this.user.representative.nationality_iso : '', Validators.required],
        'rep_birth_date': ['']
      });
    } else {
      this.userDetailsForm.addControl('address', new FormControl(this.user.user_adress ?
        this.user.user_adress.address_line_1 : '', [Validators.required]));
      this.userDetailsForm.addControl('post_code', new FormControl(this.user.user_adress ?
        this.user.user_adress.post_code : '', [Validators.required]));
      this.userDetailsForm.addControl('city', new FormControl(this.user.user_adress ?
        this.user.user_adress.city : '', [Validators.required]));
      this.userDetailsForm.addControl('country', new FormControl(this.user.user_adress ?
        this.user.user_adress.country_iso : '', [Validators.required]));
      if (this.isAssociation)
        this.userDetailsForm.addControl('assoc', new FormControl(this.user.assoc_user.assoc_id ?
          this.user.assoc_user.assoc_id : '', [Validators.required]));
    }

    this.userDetailsForm.patchValue({
      name: this.user.name,
      firstname: this.user.firstname,
      email: this.user.email,
      mobile: User.getPhone(this.user, 'mob'),
      birth_date: this.user.birth_date ? new Date(this.user.birth_date).toISOString().slice(0, 10) : ''
    });

    if (this.isCompany) {
      this.repDetailsForm.patchValue({
        rep_birth_date: this.user.representative ? new Date(this.user.representative.birth_date).toISOString().slice(0, 10) : ''
      })
    };
  }

  save(): void {
    if (this.formsHaveChanges(this.userDetailsForm, this.companyDetailsForm, this.passwordForm, this.repDetailsForm)) {
      this.validateAllFormFields(this.passwordForm);
      this.validateAllFormFields(this.userDetailsForm);

      let canPost = this.passwordForm.valid && this.userDetailsForm.valid;

      if (UserRoleEnum.COMPANY === this.user.role.id) {
        this.validateAllFormFields(this.companyDetailsForm);
        this.validateAllFormFields(this.repDetailsForm);
        canPost = this.companyDetailsForm.valid;
      }

      if (canPost) {
        const user: User = Object.assign(this.user, {
          email: this.userDetailsForm.value['email'],
          firstname: this.userDetailsForm.value['firstname'],
          name: this.userDetailsForm.value['name'],
          mob_phone: this.userDetailsForm.value['mobile'],
          birth_date: new Date(this.userDetailsForm.value['birth_date']).toUTCString(),
          user_adress: Object.assign({}, {
            address_line_1: this.isCompany ? this.companyDetailsForm.value['address'] :
              this.userDetailsForm.value['address'],
            city: this.isCompany ? this.companyDetailsForm.value['city'] :
              this.userDetailsForm.value['city'],
            post_code: this.isCompany ? this.companyDetailsForm.value['post_code'] :
              this.userDetailsForm.value['post_code'],
            country_iso: this.isCompany ? this.companyDetailsForm.value['country'] :
              this.userDetailsForm.value['country']
          })
        });

        if (UserRoleEnum.COMPANY === this.user.role.id) {
          user.entreprise = Object.assign(new Enterprise(), {
            enterprise_name: this.companyDetailsForm.value['enterprise_name'],
            siren: this.companyDetailsForm.value['siren'],
            legal_form: this.companyDetailsForm.value['legal_form'],
            mob_phone: this.companyDetailsForm.value['mob_phone']
          });
          user.entreprise.representative = Object.assign(new Representative(), {
            birth_date: new Date(this.repDetailsForm.value['rep_birth_date']).toUTCString(),
            name: this.repDetailsForm.value['rep_name'],
            firstname: this.repDetailsForm.value['rep_firstname'],
            email: this.repDetailsForm.value['rep_email'],
            nationality_iso: 'FR'
          });

        }

        if (UserRoleEnum.ASSOCIATION === this.user.role.id){
          user.assoc_user = Object.assign(new AssocUser(), {
            assoc_id: this.userDetailsForm.value['assoc'],
            id: this.user.assoc_user.id
          });
        }

        forkJoin([
          this.userService.updatePassword(Object.assign(user, this.passwordForm.value)),
          this.userService.update(user)]).subscribe(
            () => this.toastyService.success({
              title: 'F&eacute;licitation',
              msg: 'Utilisateur modifi&eacute; avec succ&egrave;s',
              showClose: true,
              timeout: 5000,
              theme: 'bootstrap',
            }),
            () => this.toastyService.error({
              title: 'Attention',
              msg: 'Une erreur s\'est produite',
              showClose: true,
              timeout: 5000,
              theme: 'bootstrap',
            }));
      } else {
        this.toastyService.error({
          title: 'Attention',
          msg: 'Merci de corriger les erreurs',
          showClose: true,
          timeout: 5000,
          theme: 'bootstrap',
        });
      }
    } else {
      this.toastyService.error({
        title: 'Attention',
        msg: 'Pas de changement detect&eacute;',
        showClose: true,
        timeout: 5000,
        theme: 'bootstrap',
      });
    }
  }

  /**
   * Validate all FormControl
   * @param formGroup FormGroup instance
   */
  private validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  private checkIfMatchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (group: FormGroup) => {
      const passwordInput = group.controls[passwordKey],
        passwordConfirmationInput = group.controls[passwordConfirmationKey];
      if (passwordInput.value !== passwordConfirmationInput.value) {
        return passwordConfirmationInput.setErrors({ notEquivalent: true });
      } else {
        return passwordConfirmationInput.setErrors(null);
      }
    };
  }

  private move(array: any[], from: number, to: number) {
    array.splice(to, 0, array.splice(from, 1)[0]);
    return array;
  };

  private formsHaveChanges(...forms: FormGroup[]): boolean {
    let result = false;
    forms.forEach(form => {
      if (!!form && form.dirty) {
        result = true;
      }
    })
    return result;
  }
}
